import { render, staticRenderFns } from "./esg.vue?vue&type=template&id=d65c0594&scoped=true"
import script from "./esg.vue?vue&type=script&lang=js"
export * from "./esg.vue?vue&type=script&lang=js"
import style0 from "./esg.vue?vue&type=style&index=0&id=d65c0594&lang=scss"
import style1 from "./esg.vue?vue&type=style&index=1&id=d65c0594&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65c0594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d65c0594')) {
      api.createRecord('d65c0594', component.options)
    } else {
      api.reload('d65c0594', component.options)
    }
    module.hot.accept("./esg.vue?vue&type=template&id=d65c0594&scoped=true", function () {
      api.rerender('d65c0594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/esg.vue"
export default component.exports